import { useQuery } from "@tanstack/react-query";
import { BookOpen, FileText, ExternalLink } from "lucide-react";
import { api } from "@/api";
import { useAuth } from "@/auth";
import { PageHeader } from "@/components/AppShell";
import { Card, SectionTitle, CardSub, LoadingState, ErrorState, EmptyState } from "@/ui";
import { C } from "@/theme";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Guides() {
  const { user } = useAuth();
  const role = user?.role;
  const guidesQ = useQuery({ queryKey: ["guides", role], queryFn: () => api.get(`/guides?role=${role}`), enabled: !!role });

  const open = (path) => window.open(`${BACKEND}${path}`, "_blank", "noopener,noreferrer");

  return (
    <div>
      <PageHeader title="Guides" subtitle="Step-by-step help for using the app" />
      {guidesQ.isLoading ? (
        <LoadingState />
      ) : guidesQ.isError ? (
        <ErrorState onRetry={guidesQ.refetch} />
      ) : (guidesQ.data ?? []).length === 0 ? (
        <EmptyState icon={<BookOpen size={44} color={C.border} />} title="No guides available yet" />
      ) : (
        <div className="grid sm:grid-cols-2 gap-4">
          {guidesQ.data.map((g) => (
            <Card key={g.file} testID={`guide-card-${g.role.toLowerCase()}`}>
              <div className="flex items-start gap-3">
                <div style={{ background: C.brandTertiary }} className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0">
                  <FileText size={22} color={C.brandPrimary} />
                </div>
                <div className="min-w-0 flex-1">
                  <SectionTitle>{g.title}</SectionTitle>
                  <CardSub>{g.description}</CardSub>
                  <button
                    data-testid={`open-guide-${g.role.toLowerCase()}`}
                    onClick={() => open(g.path)}
                    style={{ background: C.brandPrimary, color: "#fff" }}
                    className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-bold hover:opacity-90 transition-opacity"
                  >
                    <ExternalLink size={16} /> Open PDF
                  </button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
